import moment from "moment-timezone";
import store from "@/modules";

const currentTimeZone = () => store.getters["ui/currentTimezone"] || "UTC";

const outputFormat = () => {
  const tz = currentTimeZone();
  const isUSTimeZone = tz && moment.tz.zonesForCountry("US").includes(tz);
  return isUSTimeZone ? "MMM D, YYYY hh:mm A" : "D MMM, YYYY hh:mm A";
};

const formattedTime = (currentTime, inputFormat, expectedOutputFormat) => {
  if (currentTime) {
    let time = moment(currentTime);
    if (inputFormat) {
      time = moment(currentTime, inputFormat);
    }
    if (!expectedOutputFormat) {
      expectedOutputFormat = outputFormat();
    }
    return time.tz(currentTimeZone()).format(expectedOutputFormat);
  } else {
    return "No Information";
  }
};

export default Object.create({
  currentTimeZone,
  outputFormat,
  formattedTime,
});
